import {
  ADD_USER_REQUEST_ASYNC,
  ASSIGN_COMPANIES_ASYNC,
  CHANGE_ALLOWED_MSP_ROLE_ID_FILTER,
  CHANGE_ASSIGNED_COMPANIES_MSP_ROLE_FILTER,
  CHANGE_ASSIGNED_COMPANIES_PLAN_TYPE_FILTER,
  CHANGE_ASSIGNED_COMPANIES_SEARCH_FILTER,
  CHANGE_ASSIGNED_SELECTION_DATA,
  CHANGE_MSP_ROLE_FILTER,
  CHANGE_TO_ASSIGN_COMPANIES_SEARCH_FILTER,
  CHANGE_TO_ASSIGN_PLAN_TYPE_FILTER,
  CHANGE_TO_ASSIGN_SELECTION_DATA,
  CNC_ACCESS_REQUEST_ASYNC,
  COMPANY_USERS_REQUEST_ASYNC,
  DATA_REQUEST_ASYNC,
  DELETE_USER_REQUEST_ASYNC,
  FILTER_SEARCH_CHANGE,
  FILTER_SEARCH_RESET,
  GET_MANAGEABLE_COMPANIES_ASYNC,
  GET_USER_INFO_ASYNC,
  GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC,
  GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC,
  MAKE_OWNER_ASYNC,
  PROFILES_REQUEST_ASYNC,
  RESET_ASSIGNED_SELECTION_DATA,
  RESET_TO_ASSIGN_SELECTION_DATA,
  RESET_USERS,
  ROLE_FILTER_CHANGE,
  SEARCH_CHANGE,
  SET_ASSIGNED_COMPANIES_FILTER,
  SET_ASSIGNED_COMPANIES_FILTER_PAGE,
  SET_TO_ASSIGN_COMPANIES_PAGE,
  SET_TO_ASSIGN_DRAWER_OPEN,
  SET_USER_ASSIGNED_COMPANIES_PAGE,
  UNASSIGN_COMPANIES_ASYNC,
  UPDATE_CNC_ACCESS_REQUEST_ASYNC,
  UPDATE_USER_REQUEST_ASYNC,
} from './constants'

const getProfiles = () => ({ type: PROFILES_REQUEST_ASYNC.INITIATE })
export const getProfilesSuccess = (data) => ({
  type: PROFILES_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getProfilesError = (error) => ({
  type: PROFILES_REQUEST_ASYNC.ERROR,
  error,
})
const getProfilesCancel = () => ({ type: PROFILES_REQUEST_ASYNC.CANCEL })

const getCompanyUsers = () => ({ type: COMPANY_USERS_REQUEST_ASYNC.INITIATE })
export const getCompanyUsersSuccess = (data) => ({
  type: COMPANY_USERS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getCompanyUsersError = (error) => ({
  type: COMPANY_USERS_REQUEST_ASYNC.ERROR,
  error,
})
const getCompanyUsersCancel = () => ({
  type: COMPANY_USERS_REQUEST_ASYNC.CANCEL,
})

const addCompanyUser = (user) => ({
  type: ADD_USER_REQUEST_ASYNC.INITIATE,
  payload: { user },
})
export const addCompanyUserSuccess = () => ({
  type: ADD_USER_REQUEST_ASYNC.SUCCESS,
})
export const addCompanyUserError = (error) => ({
  type: ADD_USER_REQUEST_ASYNC.ERROR,
  error,
})
const addCompanyUserCancel = () => ({ type: ADD_USER_REQUEST_ASYNC.CANCEL })

const delCompanyUser = (user) => ({
  type: DELETE_USER_REQUEST_ASYNC.INITIATE,
  payload: { user },
})
export const delCompanyUserSuccess = () => ({
  type: DELETE_USER_REQUEST_ASYNC.SUCCESS,
})
export const delCompanyUserError = (error) => ({
  type: DELETE_USER_REQUEST_ASYNC.ERROR,
  error,
})
const delCompanyUserCancel = () => ({ type: DELETE_USER_REQUEST_ASYNC.CANCEL })

const updCompanyUser = (user) => ({
  type: UPDATE_USER_REQUEST_ASYNC.INITIATE,
  payload: { user },
})
export const updCompanyUserSuccess = () => ({
  type: UPDATE_USER_REQUEST_ASYNC.SUCCESS,
})
export const updCompanyUserError = (error) => ({
  type: UPDATE_USER_REQUEST_ASYNC.ERROR,
  error,
})
const updCompanyUserCancel = () => ({ type: UPDATE_USER_REQUEST_ASYNC.CANCEL })

const makeOwner = (user) => ({
  type: MAKE_OWNER_ASYNC.INITIATE,
  payload: { user },
})
export const makeOwnerSuccess = () => ({ type: MAKE_OWNER_ASYNC.SUCCESS })
export const makeOwnerError = (error) => ({
  type: MAKE_OWNER_ASYNC.ERROR,
  error,
})
const makeOwnerCancel = () => ({ type: MAKE_OWNER_ASYNC.CANCEL })

export const fetchMailboxData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
const fetchMailboxDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })
export const fetchMailboxDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchMailboxDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})

export const fetchCncAccess = () => ({
  type: CNC_ACCESS_REQUEST_ASYNC.INITIATE,
})
const fetchCncAccessCancel = () => ({ type: CNC_ACCESS_REQUEST_ASYNC.CANCEL })
export const fetchCncAccessSuccess = (cncAccess) => ({
  type: CNC_ACCESS_REQUEST_ASYNC.SUCCESS,
  payload: { cncAccess },
})
export const fetchCncAccessError = (error) => ({
  type: CNC_ACCESS_REQUEST_ASYNC.ERROR,
  error,
})

export const updateCncAccess = (cncAccess) => ({
  type: UPDATE_CNC_ACCESS_REQUEST_ASYNC.INITIATE,
  payload: { cncAccess },
})
export const updateCncAccessCancel = () => ({
  type: UPDATE_CNC_ACCESS_REQUEST_ASYNC.CANCEL,
})
export const updateCncAccessSuccess = () => ({
  type: UPDATE_CNC_ACCESS_REQUEST_ASYNC.SUCCESS,
})
export const updateCncAccessError = (error) => ({
  type: UPDATE_CNC_ACCESS_REQUEST_ASYNC.ERROR,
  error,
})

export const getManageableCompanies = (params) => ({
  type: GET_MANAGEABLE_COMPANIES_ASYNC.INITIATE,
  payload: { params },
})
export const getManageableCompaniesSuccess = (data) => ({
  type: GET_MANAGEABLE_COMPANIES_ASYNC.SUCCESS,
  payload: { data },
})
export const getManageableCompaniesError = (error) => ({
  type: GET_MANAGEABLE_COMPANIES_ASYNC.ERROR,
  error,
})
export const getManageableCompaniesCancel = () => ({
  type: GET_MANAGEABLE_COMPANIES_ASYNC.CANCEL,
})

export const getManageableUserAssignedCompanies = () => ({
  type: GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC.INITIATE,
})
export const getManageableUserAssignedCompaniesSuccess = (data) => ({
  type: GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC.SUCCESS,
  payload: { data },
})
export const getManageableUserAssignedCompaniesError = (error) => ({
  type: GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC.ERROR,
  error,
})
export const getManageableUserAssignedCompaniesCancel = () => ({
  type: GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC.CANCEL,
})

export const getManageableUserToAssignCompanies = () => ({
  type: GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.INITIATE,
})
export const getManageableUserToAssignCompaniesSuccess = (data) => ({
  type: GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.SUCCESS,
  payload: { data },
})
export const getManageableUserToAssignCompaniesError = (error) => ({
  type: GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.ERROR,
  error,
})
export const getManageableUserToAssignCompaniesCancel = () => ({
  type: GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.CANCEL,
})

export const getUserInfo = (id) => ({
  type: GET_USER_INFO_ASYNC.INITIATE,
  payload: { id },
})
export const getUserInfoSuccess = (data) => ({
  type: GET_USER_INFO_ASYNC.SUCCESS,
  payload: { data },
})
export const getUserInfoError = (error) => ({
  type: GET_USER_INFO_ASYNC.ERROR,
  error,
})
export const getUserInfoCancel = () => ({
  type: GET_USER_INFO_ASYNC.CANCEL,
})

export const assignCompanies = () => ({
  type: ASSIGN_COMPANIES_ASYNC.INITIATE,
})
export const assignCompaniesSuccess = () => ({
  type: ASSIGN_COMPANIES_ASYNC.SUCCESS,
})
export const assignCompaniesError = (error) => ({
  type: ASSIGN_COMPANIES_ASYNC.ERROR,
  error,
})
export const assignCompaniesCancel = () => ({
  type: ASSIGN_COMPANIES_ASYNC.CANCEL,
})

export const unassignMSPCompanies = () => ({
  type: UNASSIGN_COMPANIES_ASYNC.INITIATE,
})
export const unassignMSPCompaniesSuccess = () => ({
  type: UNASSIGN_COMPANIES_ASYNC.SUCCESS,
})
export const unassignMSPCompaniesError = (error) => ({
  type: UNASSIGN_COMPANIES_ASYNC.ERROR,
  error,
})
export const unassignMSPCompaniesCancel = () => ({
  type: UNASSIGN_COMPANIES_ASYNC.CANCEL,
})

const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const filterSearchChange = (q) => ({ type: FILTER_SEARCH_CHANGE, payload: { q } })
const filterSearchReset = () => ({ type: FILTER_SEARCH_RESET })
const roleFilterChange = (value) => ({ type: ROLE_FILTER_CHANGE, payload: { value } })
const changeMspRoleFilter = (value) => ({ type: CHANGE_MSP_ROLE_FILTER, payload: { value } })
const setAssignedCompaniesFilter = (data) => ({
  type: SET_ASSIGNED_COMPANIES_FILTER,
  payload: { data },
})
const setAssignedCompaniesFilterPage = (page) => ({
  type: SET_ASSIGNED_COMPANIES_FILTER_PAGE,
  payload: { page },
})
const resetUsers = () => ({
  type: RESET_USERS,
})
export const changeAssignedCompaniesSearchFilter = (q) => ({
  type: CHANGE_ASSIGNED_COMPANIES_SEARCH_FILTER,
  payload: { q },
})
export const changeToAssignCompaniesSearchFilter = (q) => ({
  type: CHANGE_TO_ASSIGN_COMPANIES_SEARCH_FILTER,
  payload: { q },
})
export const changeAssignedCompaniesMSPRoleFilter = (value) => ({
  type: CHANGE_ASSIGNED_COMPANIES_MSP_ROLE_FILTER,
  payload: { value },
})
export const changeAssignedCompaniesPlanTypeFilter = (value) => ({
  type: CHANGE_ASSIGNED_COMPANIES_PLAN_TYPE_FILTER,
  payload: { value },
})
export const changeAllowedMspRoleIdFilter = (value) => ({
  type: CHANGE_ALLOWED_MSP_ROLE_ID_FILTER,
  payload: { value },
})
export const setUserAssignedCompaniesPage = (page) => ({
  type: SET_USER_ASSIGNED_COMPANIES_PAGE,
  payload: { page },
})
export const setToAssignCompaniesPage = (page) => ({
  type: SET_TO_ASSIGN_COMPANIES_PAGE,
  payload: { page },
})
export const changeToAssignSelectionData = (field, value) => ({
  type: CHANGE_TO_ASSIGN_SELECTION_DATA,
  payload: { field, value },
})
export const changeAssignedSelectionData = (field, value) => ({
  type: CHANGE_ASSIGNED_SELECTION_DATA,
  payload: { field, value },
})
export const setIsToAssignDrawerOpen = (value) => ({
  type: SET_TO_ASSIGN_DRAWER_OPEN,
  payload: { value },
})
export const changeToAssignPlanTypeFilter = (value) => ({
  type: CHANGE_TO_ASSIGN_PLAN_TYPE_FILTER,
  payload: { value },
})
export const resetToAssignSelectionData = () => ({
  type: RESET_TO_ASSIGN_SELECTION_DATA,
})
export const resetAssignedSelectionData = () => ({
  type: RESET_ASSIGNED_SELECTION_DATA,
})

export default {
  // to props
  getCompanyUsers,
  getCompanyUsersCancel,
  getProfiles,
  getProfilesCancel,
  delCompanyUser,
  delCompanyUserCancel,
  addCompanyUser,
  addCompanyUserCancel,
  updCompanyUser,
  updCompanyUserCancel,
  makeOwner,
  makeOwnerCancel,
  searchChange,
  fetchMailboxDataCancel,
  fetchCncAccessCancel,
  fetchCncAccess,
  updateCncAccess,
  filterSearchChange,
  filterSearchReset,
  roleFilterChange,
  changeMspRoleFilter,
  getManageableCompanies,
  getManageableCompaniesCancel,
  setAssignedCompaniesFilter,
  setAssignedCompaniesFilterPage,
  resetUsers,
  getManageableUserAssignedCompanies,
  getManageableUserAssignedCompaniesCancel,
  changeAssignedCompaniesMSPRoleFilter,
  changeAssignedCompaniesPlanTypeFilter,
  changeToAssignSelectionData,
}
